import {
  activeLenders,
  clientsAccounts,
  businessFundingSearches,
  creditLinesFacilityMap,
  facilitiesMap,
  deleteFacility,
  saveFacilityType,
  ADD_WIZZARD_CREDIT_FACILITY,
  ADD_WIZZARD_LEDGER_PROVIDER_FACILITY,
  CLOSE_WIZZARD,
  CLOSE_WIZZARD_DATA_LOADING_ERROR_MODAL,
  CLOSE_WIZZARD_DATA_LOADING_MODAL,
  OPEN_WIZZARD,
  OPEN_WIZZARD_DATA_LOADING_ERROR_MODAL,
  OPEN_WIZZARD_DATA_LOADING_MODAL,
  SET_WIZZARD_ACCOUNTING_SOLUTION,
  SET_WIZZARD_CLIENT,
  REMOVE_WIZZARD_CREDIT_FACILITY,
  REMOVE_WIZZARD_LEDGER_PROVIDER_FACILITY,
  SET_WIZZARD_PROVIDER_MAP_VALIDITY,
  TRIGGER_XERO_UPLOAD,
  SAVE_INTEGRATION_PAYLOAD,
  RESET_INTEGRATION_PAYLOAD,
  ADD_CONNECTION_HISTORY_LIST_ITEM,
  REMOVE_CONNECTION_HISTORY_LIST_ITEM,
  UPDATE_CONNECTION_HISTORY_LIST_ITEM,
  SET_EDIT_FACILITY_WIZZARD,
} from './types';

export const addMonitorWizzardCreditFacility = (account) => ({
  type: ADD_WIZZARD_CREDIT_FACILITY,
  account,
});

export const addMonitorWizzardLedgerProviderFacility = (providerFacility) => ({
  type: ADD_WIZZARD_LEDGER_PROVIDER_FACILITY,
  providerFacility,
});

export function closeMonitorWizzard() {
  return {
    type: CLOSE_WIZZARD,
  };
}

export function closeMonitorWizzardDataLoadingErrorModal() {
  return {
    type: CLOSE_WIZZARD_DATA_LOADING_ERROR_MODAL,
  };
}

export function closeMonitorWizzardDataLoadingModal() {
  return {
    type: CLOSE_WIZZARD_DATA_LOADING_MODAL,
  };
}

export function openMonitorWizzard(startPath = false, options) {
  return {
    type: OPEN_WIZZARD,
    startPath,
    options,
  };
}

export function openMonitorWizzardDataLoadingErrorModal() {
  return {
    type: OPEN_WIZZARD_DATA_LOADING_ERROR_MODAL,
  };
}

export function openMonitorWizzardDataLoadingModal() {
  return {
    type: OPEN_WIZZARD_DATA_LOADING_MODAL,
  };
}

export const postCreditLinesFacilityMap = (entityId, payload, promise) => ({
  type: creditLinesFacilityMap.request,
  entityId,
  payload,
  promise,
});

export const saveFacility = (entityId, payload, isNewFacility, promise) => ({
  type: saveFacilityType.request,
  entityId,
  payload,
  isNewFacility,
  promise,
});

export const saveFacilitySuccess = (payload) => ({
  type: saveFacilityType.success,
  payload,
});

export const removeMonitorWizzardCreditFacility = (uuid) => ({
  type: REMOVE_WIZZARD_CREDIT_FACILITY,
  uuid,
});

export const removeMonitorWizzardLedgerProviderFacility = (providerId) => ({
  type: REMOVE_WIZZARD_LEDGER_PROVIDER_FACILITY,
  providerId,
});

export const requestClientAccounts = (entityId, promise) => ({
  type: clientsAccounts.request,
  entityId,
  promise,
});

export const requestClientAccountsSuccess = (response) => ({
  type: clientsAccounts.success,
  response,
});

export const requestActiveLenders = () => ({
  type: activeLenders.request,
});

export const requestActiveLendersSuccess = (response) => ({
  type: activeLenders.success,
  response,
});

export const requestBusinessFundingSearches = (entityId, promise) => ({
  type: businessFundingSearches.request,
  entityId,
  promise,
});

export const requestLendersSuccess = (response) => ({
  type: businessFundingSearches.success,
  response,
});

export function setMonitorWizzardAccountingSolution(accountingSolution) {
  return {
    type: SET_WIZZARD_ACCOUNTING_SOLUTION,
    accountingSolution,
  };
}

export function setMonitorWizzardClient(client) {
  return {
    type: SET_WIZZARD_CLIENT,
    client,
  };
}

export function setEditFacilityWizzard(id) {
  return {
    type: SET_EDIT_FACILITY_WIZZARD,
    id,
  };
}

export const requestFacilitiesMap = (entityId, promise) => ({
  type: facilitiesMap.request,
  entityId,
  promise,
});

export const requestDeleteFacility = (entityId, id, promise) => ({
  type: deleteFacility.request,
  entityId,
  id,
  promise,
});

export const requestFacilitiesMapSuccess = (payload) => ({
  type: facilitiesMap.success,
  payload,
});

export function setMonitorWizzardProviderFacilityValid(valid) {
  return {
    type: SET_WIZZARD_PROVIDER_MAP_VALIDITY,
    valid,
  };
}

export const triggerXeroUpload = (entityId, startPath) => ({
  type: TRIGGER_XERO_UPLOAD,
  entityId,
  startPath,
});

export const saveIntegrationFilePayload = (payload) => ({
  type: SAVE_INTEGRATION_PAYLOAD,
  payload,
});

export const resetIntegrationFilePayload = () => ({
  type: RESET_INTEGRATION_PAYLOAD,
});

export const addConnectionHistoryListItem = (item) => ({
  type: ADD_CONNECTION_HISTORY_LIST_ITEM,
  item,
});

export const removeConnectionHistoryListItem = (id) => ({
  type: REMOVE_CONNECTION_HISTORY_LIST_ITEM,
  id,
});

export const updateConnectionHistoryListItem = (payload) => ({
  type: UPDATE_CONNECTION_HISTORY_LIST_ITEM,
  payload,
});
